<app-standard-page>
  <mat-card>
    <h2>Anmelden</h2>
    <form #loginForm id="loginForm" (ngSubmit)="onSubmit()">
      <p>
        <mat-form-field color="accent">
          <input matInput type="email" name="email" placeholder="E-Mail" [formControl]="emailFormControl"
                 required email/>
          <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
            Geben Sie bitte eine gültige E-Mail-Adresse an.
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('required')">
            Die E-Mail-Adresse ist erforderlich.
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('cred_found')">
            E-Mail oder Passwort falsch.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field color="accent">
          <input name="password"
                 placeholder="Passwort"
                 [formControl]="passwordFormControl"
                 required
                 matInput
                 [type]="hidePW ? 'password' : 'text'">
          <button type="button" mat-icon-button matSuffix (click)="hidePW = !hidePW" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePW">
            <mat-icon>{{hidePW ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>

          <mat-error *ngIf="passwordFormControl.hasError('required')">
            Bitte geben Sie ein Passwort ein.
          </mat-error>
          <mat-error *ngIf="passwordFormControl.hasError('cred_found')">
            E-Mail oder Passwort falsch.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <button mat-flat-button color="accent" type="submit">Anmelden</button>
      </p>
<!--      <p><a class="lost-pw" target="_blank" href="{{ssoClientUrl}}passwort-vergessen/">Passwort vergessen?</a></p>-->
    </form>
  </mat-card>
</app-standard-page>
